import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Sorn from '../views/Sorn.vue'
import callNote from '../views/call-note.vue'
const AppSelection = () => import('../views/AppSelection.vue')
import MyAccount from '../views/MyAccount.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/sorn',
    name: 'sorn',
    component: Sorn,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresSornAuth: true },
  },
  {
    path: '/call-note',
    name: 'callNote',
    component: callNote,
    meta: { requiresSornAuth: true },
  },
  {
    path: '/',
    name: 'appSelection',
    component: AppSelection,
    meta: { requiresAuth: true },
  },
  {
    path: '/myAccount',
    name: 'myAccount',
    component: MyAccount,
    meta: { requiresAuth: true },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: 'login',
  routes,
})

router.beforeEach((to, from, next) => {
  const loggedIn = !!document.cookie
    .split('; ')
    .find((row) => row.startsWith('id'))
  const sorn = !!document.cookie
    .split('; ')
    .find((row) => row.startsWith('sorn_accepted'))
  if (to.matched.some((record) => record.meta.requiresSornAuth) && !sorn) {
    next('/sorn')
  } else if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !loggedIn
  ) {
    next('/login')
  } else {
    next()
  }
})

export default router
